<div class="main">
  <div id="overlaySpinner" style="display:none;">
    <div class="spinner"></div>
    <br /> Loading...
  </div>
  <!-- Preloader -->
  <div class="loader-mask" *ngIf="loader == true">
    <div class="loader">
      <div></div>
      <div></div>
    </div>
  </div>
  <!-- Preloader -->
  <header class="main-header dark-mode-background-theme-colors">
    <nav class="navbar navbar-fixed-top mb-0">
      <div class="container-fluid mainHeaderPart pl-2 pr-2">
        <div class="col-3 col-lg-3 col-xs-4 col-sm-3 col-md-3 p-0 pr-2">
          <div class="row strict">
            <div class="col-6 col-sm-3 col-xs-12 col-lg-6 col-md-7 navbarheaderbackgroundcolor cursorArrow">
              <a class="main-nav-a img floatleft">
                <img class="logo logo-only" src="./assets/images/stag_logo.png" alt="logo">
              </a>
              <a class="main-nav-a img floatleft">
                <img class="logo logo-icon-only" src="./assets/images/logo-icon-only.png" alt="logo">
              </a>
            </div>
            <div class="col-6 col-sm-9 col-lg-6 col-md-5 toggleLeftMenu">
              <ul class="nav navbar-nav navbar-left toggleLeftMenu w-100 mr-0">
                <li>
                  <div id="hamburger" (click)="openMenu('menu')">
                    <input type="checkbox" data-toggle="modal" data-target="#hamburgerMenu" />
                    <fa-icon class="fa icon setting-icon" [icon]="faCog"></fa-icon>
                  </div>
                </li>
                <li class="usernameListItem" title="{{userName}}">
                  <a class="main-nav-a usernameListA dark-mode-background-theme-colors">
                    <span>{{userName}}</span>
                  </a>
                </li>
                <!-- <li *ngIf="projectOpen != true">
                  <label class="switch" style="margin-top: 25% !important;">
                    <input type="checkbox" (click)="onFocusModeBeforeProject($event.target.checked)" [checked]="checkFocusMode()">
                    <span class="slider round"></span>
                  </label>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="col-9 col-lg-9 col-sm-9 col-md-9 col-xs-8 p-0" *ngIf="projectOpen == true">
          <div class="row strict">
            <div class="col-8 col-xs-8 col-sm-8 col-md-8 col-lg-8 toggleLeftMenu">
              <!-- *ngIf="currentView !== 'entityTest'" -->
              <ul class="nav navbar-nav toggleLeftMenu leftMenuPadding w-100 pl-0" *ngIf="focusMode == false">
                <li id="recon-option" *ngIf="projectOpen == true" class="dropdown headerMenuDropdown tool-heading">
                  <a class="dropdown-toggle main-nav-a headerAnchorText" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-7 col-xs-offset-4">
                        {{ 'menu.recon' | translate }} &nbsp;&nbsp;
                        <fa-icon class="fas icon-black" [icon]="faAngleDown"></fa-icon>
                      </div>
                      <div class=" col-xs-offset-1">
                      </div>
                    </div>
                  </a>
                  <ul class="dropdown-menu square menuItemsClrBlack">
                    <li class="main-menu-dropdown-li" (click)="openTool('landscaper')" routerLink="/main/landscaper">
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faMountain"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.landscape' | translate }}
                        </div>
                      </div>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Pm')"
                      *ngIf="sessionProjectData.persona.length == 0 || sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faUser"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.personaMapper' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li id="persona_mapper_option" class="main-menu-dropdown-li"
                      (click)="openTool('personaMapperMindMap');createActivity('Pm')"
                      routerLink="/main/personaMapperMindMap"
                      *ngIf="sessionProjectData.persona.length != 0 && sessionProjectData.listOfEUTs.length != 0">
                      <!-- (click)="project.views.open('Pm');personaMapper.init();interactionMapper.init();interactionMapper.controller.interactionGraphShowHide(true);scopeMapper.controller.scopeGraphShowHide(true);" -->

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faUser"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.personaMapper' | translate }}
                        </div>
                      </div>
                    </li>
                    <li role="separator" class="divider"></li>

                    <li class="main-menu-dropdown-li" *ngIf="sessionProjectData.listOfEUTs.length != 0"
                      (click)="openTool('interactionMapperMindMap');createActivity('Im')"
                      routerLink="/main/interactionMapperMindMap">
                      <!-- (click)="project.views.open('Im');interactionMapper.init();interactionMapper.controller.interactionGraphShowHide(true);scopeMapper.controller.scopeGraphShowHide(true);" -->
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faConnectdevelop"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.interactionMapper' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Im')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">
                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faConnectdevelop"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.interactionMapper' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <!-- <li class="main-menu-dropdown-li" *ngIf="sessionProjectData.listOfEUTs.length != 0"
                    (click)="openTool('interactionMapperMindMap');createActivity('Imm')" routerLink="/main/interactionMapperMindMap">
                    <div class="row strict">
                      <div class="col-xs-1 col-xs-offset-1">
                        <fa-icon class="fas icon-black" [icon]="faConnectdevelop"></fa-icon>
                      </div>
                      <div class="col-xs-9 col-xs-offset-1">
                        {{ 'menu.interactionMapper' | translate }} Mindmap
                      </div>
                    </div>
                  </li>
                  <li role="separator" class="divider"></li> -->

                    <li class="main-menu-dropdown-li" (click)="openTool('scopeMapperMindMap');createActivity('Sc')"
                      routerLink="/main/scopeMapperMindMap" *ngIf=" sessionProjectData.listOfEUTs.length != 0">
                      <!-- (click)="project.views.open('Sc');interactionMapper.init();interactionMapper.controller.interactionGraphShowHide(true);scopeMapper.init();scopeMapper.controller.scopeGraphShowHide(true);" -->
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faCubes"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.scopeMapper' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Sc')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faCubes"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.scopeMapper' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('environmentMapper');createActivity('Ed')"
                      routerLink="/main/environmentMapper" *ngIf="sessionProjectData.listOfEnv.length != 0">
                      <!-- (click)="project.views.open('Ed')" -->

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="far icon-black" [icon]="faObjectGroup"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.environmentMapper' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Ed')"
                      *ngIf="sessionProjectData.listOfEnv.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="far icon-black" [icon]="faObjectGroup"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.environmentMapper' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('taskPlanner');createActivity('Tp')"
                      routerLink="/main/taskPlanner">
                      <!-- (click)="project.views.open('Tp1');taskPlanner1.init()" -->

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faTasks"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.taskPlanner' | translate }}
                        </div>
                      </div>
                    </li>

                    <!-- <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('mindMapping');createActivity('Mm')"
                    routerLink="/main/mindMapping">
                    <div class="row strict">
                      <div class="col-xs-1 col-xs-offset-1">
                        <fa-icon class="fas icon-black" [icon]="faSitemap"></fa-icon>
                      </div>
                      <div class="col-xs-9 col-xs-offset-1">
                        Mind mapper
                      </div>
                    </div>
                  </li> -->
                    <!-- <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('entityTest');createActivity('Sp1')"
                      routerLink="/main/entityTest">
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faBug"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          Entity Test
                        </div>
                      </div>
                    </li> -->
                    <!-- <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('taskPlanner');createActivity('Tp1')"
                      routerLink="/main/taskPlanner" *ngIf="sessionProjectData.listOfEUTs.length != 0">

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faTasks"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.taskPlanner' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Tp')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faTasks"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.taskPlanner' | translate }}
                          </div>
                        </div>
                      </a>
                    </li> -->
                  </ul>
                </li>
                <li *ngIf="projectOpen == true" class="dropdown headerMenuDropdown tool-heading">
                  <a class="dropdown-toggle main-nav-a headerAnchorText" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-7 col-xs-offset-4">
                        {{ 'menu.explore' | translate }} &nbsp;&nbsp;
                        <fa-icon class="fas icon-black" [icon]="faAngleDown"></fa-icon>
                      </div>
                      <div class="col-xs-offset-1">
                      </div>
                    </div>
                  </a>


                  <ul class="dropdown-menu square menuItemsClrBlack">
                    <li class="main-menu-dropdown-li" (click)="openTool('deepDive');createActivity('Dd')"
                      routerLink="/main/deepDive" *ngIf="modelData.listOfEUTs.length != 0">
                      <!-- (click)="project.views.open('Dd');deepDive.init()" -->

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faSkiing"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.deepdive' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Dd')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faSkiing"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.deepdive' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li activityPage"
                      (click)="openTool('testDesigner');createActivity('Td')" routerLink="/main/testDesigner"
                      *ngIf="sessionProjectData.listOfEUTs.length != 0">
                      <!-- (click)="project.views.open('Td');createDesignerActivity();" -->


                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faPenNib"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.designer' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Td')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faPenNib"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.designer' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li activityPage" (click)="openTool('checklist')"
                      routerLink="/main/checklist">
                      <!-- (click)="project.views.open('Cl');createActivity('Cl');checklist.controller.checklistNoteLoad(true)" -->
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faListOl"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.checklist' | translate }}
                        </div>
                      </div>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('testExecutor')" routerLink="/main/testExecutor"
                      *ngIf="sessionProjectData.listOfEUTs.length != 0">
                      <!-- (click)="project.views.open('Ex');createActivity('Ex');createValidatorActivity();validator.model.envMapListGenerate()" -->

                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faRunning"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.executor' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Ex')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faRunning"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.executor' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" class="divider"></li>
                    <li class="main-menu-dropdown-li" (click)="openTool('testManager')" routerLink="/main/testManager"
                      *ngIf="sessionProjectData.persona.length != 0 && sessionProjectData.listOfEUTs.length != 0">
                      <div class="row strict">

                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faClipboardList"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.testmanager' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Tm')"
                      *ngIf="sessionProjectData.persona.length == 0 || sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faClipboardList"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.testmanager' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </li>
                <li *ngIf="projectOpen == true" class="dropdown headerMenuDropdown tool-heading">
                  <a class="dropdown-toggle main-nav-a headerAnchorText" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-7 col-xs-offset-4">
                        {{ 'menu.recoup' | translate }} &nbsp;&nbsp;
                        <fa-icon class="fas icon-black" [icon]="faAngleDown"></fa-icon>
                      </div>
                      <div class="col-xs-offset-1">
                      </div>
                    </div>
                  </a>
                  <ul class="dropdown-menu square menuItemsClrBlack">

                    <li class="main-menu-dropdown-li" routerLink="/main/dashboardTest"
                      (click)="openTool('dashboardTest');createActivity('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length != 0">
                      <!-- dashboardComponent.loadDashboards();dashboardComponent.loadDashboardsUI();dashboardComponent.setDashboard('testCaseQuality') -->
                      <!-- (click)="project.views.open('Db')" -->
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faTh"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.testdashboard' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faTh"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.testdashboard' | translate }}
                          </div>
                        </div>
                      </a>
                    </li>
                    <li role="separator" *ngIf="membership == 1" class="divider"></li>
                    <li class="main-menu-dropdown-li" *ngIf="membership == 1" (click)="openTool('jirabugsMapper');createActivity('Bm')"
                      routerLink="/main/jirabugsMapper">
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faBug"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.bugsmapper' | translate }}
                        </div>
                      </div>
                    </li>
                    <!-- <li role="separator" class="divider"></li>

                    <li class="main-menu-dropdown-li" routerLink="/main/dashboardExecution"
                      (click)="openTool('dashboardExecution');createActivity('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length != 0">
                
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faTachometerAlt"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.execdashboard' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faTachometerAlt"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.execdashboard' | translate }}
                          </div>
                        </div>
                      </a>
                    </li> -->
                    <!-- <li role="separator" class="divider"></li> -->

                    <!-- <li class="main-menu-dropdown-li" routerLink="/main/dashboardQuality"
                      (click)="openTool('dashboardQuality');createActivity('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length != 0">
                      
                      <div class="row strict">
                        <div class="col-xs-1 col-xs-offset-1">
                          <fa-icon class="fas icon-black" [icon]="faChartLine"></fa-icon>
                        </div>
                        <div class="col-xs-9 col-xs-offset-1">
                          {{ 'menu.qtydashboard' | translate }}
                        </div>
                      </div>
                    </li>
                    <li class="main-menu-dropdown-li" (click)="errorMsgPopup('Db')"
                      *ngIf="sessionProjectData.listOfEUTs.length == 0">

                      <a class="navbar-toggler toggler-example emptyToolLink p-0" type="button" data-toggle="modal"
                        data-target="#EmptyDataPopup">
                        <div class="row strict">
                          <div class="col-xs-1 col-xs-offset-1">
                            <fa-icon class="fas icon-black" [icon]="faChartLine"></fa-icon>
                          </div>
                          <div class="col-xs-9 col-xs-offset-1">
                            {{ 'menu.qtydashboard' | translate }}
                          </div>
                        </div>
                      </a>
                    </li> -->
                  </ul>
                </li>
              </ul>
            </div>
            <div class="col-4 col-sm-4 col-xs-12 col-md-4 col-lg-4">
              <div class="row strict">
                <div class="col-1 col-xl-1 col-lg-1 col-sm-2 header-icons">
                  <div class="readOnlyModeBtn cursorPointer" (click)="disableReadModeBtn != true && readmode(readStatus)">
                    <span class="icon-bar" *ngIf="readStatus==false">
                      <fa-icon class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faUnlock"></fa-icon>
                    </span>
                    <span class="icon-bar" *ngIf="readStatus==true">
                      <fa-icon class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faLock"></fa-icon>
                    </span>
                  </div>
                </div>
                <div class="col-6 col-xl-6 col-lg-6 col-sm-5">
                  <div class="row strict toogleBtn">
                    <div class="col col-xs-5 col-sm-5">
                      <div class="navbar-text margintop13px marginbottom13px" title="{{userName}}">
                        <span>{{userName}}</span>
                      </div>
                    </div>

                    <div class="col col-xs-6 col-sm-6">
                      <div class="row strict">
                        <div class="col col-xs-2 col-sm-2">
                          <div class="readOnlyModeBtn floatright cursorPointer"
                            (click)="disableReadModeBtn != true && readmode(readStatus)">
                            <span class="icon-bar" *ngIf="readStatus==false">
                              <fa-icon class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faUnlock"></fa-icon>
                            </span>
                            <span class="icon-bar" *ngIf="readStatus==true">
                              <fa-icon class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faLock"></fa-icon>
                            </span>
                          </div>
                        </div>
                        <div class="col col-xs-2 col-sm-2">
                          <div class="floatright" *ngIf="projectOpen == true">
                            <fa-icon data-toggle="modal" (click)="openMyNotes()"
                              class="fas icon setting-icon w-100 mr-0 ml-0" style="color: yellow !important;"
                              [icon]="faStickyNote"></fa-icon>
                            <!-- (click)="note.controller.switchNoteLayout(false);createActivity('Snt')" data-target="#myNote"-->
                          </div>
                        </div>
                        <div class="col col-xs-2 col-sm-2">
                          <div class="floatright" *ngIf="projectOpen == true">
                            <fa-icon *ngIf="networkConnection == true" class="fas icon setting-icon w-100 mr-0 ml-0"
                              [icon]="faLink"></fa-icon>
                            <fa-icon *ngIf="networkConnection == false" class="fas icon setting-icon w-100 mr-0 ml-0"
                              [icon]="faUnlink"></fa-icon>
                          </div>
                        </div>
                        <div class="col col-xs-2 col-sm-2">
                          <div class="floatright cursorPointer" *ngIf="projectOpen == true">
                            <fa-icon *ngIf="chatUpdateColor == false"
                              (click)="disableReadModeBtn != true && currentActiveUsers.length > 1 && openChatBoxModal();openChatPopup()"
                              class="far icon setting-icon w-100 mr-0 ml-0" [icon]="faComments"></fa-icon>
                            <fa-icon *ngIf="chatUpdateColor == true"
                              style="color: yellow !important; font-size: 23px !important;"
                              (click)="disableReadModeBtn != true && currentActiveUsers.length > 1 && openChatBoxModal();openChatPopup()"
                              class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faComments"></fa-icon>
                            <span class='badge badge-light' id='activeUserCount'
                              (click)="disableReadModeBtn != true && currentActiveUsers.length > 1 && openChatBoxModal();openChatPopup()">{{currentActiveUsersCount}}</span>
                          </div>
                        </div>

                        <div class="col col-xs-2 col-sm-2">
                          <div class="floatright cursorPointer">
                            <fa-icon class="far icon setting-icon w-100 mr-0 ml-0" [icon]="faBell" data-toggle="modal"
                              data-target="#notifySection"
                              (click)="createActivity('No');notificationsComponent.getNotifications();notificationsComponent.getAllNotifications(0, loginDetails.registeredOn)">
                            </fa-icon>
                            <span class='badge badge-light' id='unreadNotifications'
                              (click)="createActivity('No');notificationsComponent.getNotifications();notificationsComponent.getAllNotifications(0, loginDetails.registeredOn)"
                              data-toggle="modal"
                              data-target="#notifySection">{{notificationsComponent.unreadNotificationCount}}</span>
                          </div>
                        </div>
                        <div class="col col-xs-1 col-sm-1">
                          <div class="floatright" (click)="openNav()">
                            <fa-icon class="fas icon setting-icon w-100 mr-0 ml-0" [icon]="faBars"></fa-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="navbar-text project-name w-70 pr-1 mb-0">
                    <label class="title heading" *ngIf="projectOpen == true">
                      [{{sessionProjectData.projectDetails.name}}]
                    </label>
                  </p>
                  <label class="switch">
                    <input type="checkbox" (click)="onFocusMode($event.target.checked)" [checked]="checkFocusMode()">
                    <span class="slider round"></span>
                  </label>
                </div>
                <div class="col-5 col-xl-5 col-lg-5 col-sm-5 header-icons">
                  <div class="row strict">
                    <!-- <div class="col-1 col-sm-1">
                      
                    </div> -->
                    <div class="col-3 col-sm-3">
                      <div class="" *ngIf="projectOpen == true">

                        <div class="" type="button">
                          <fa-icon *ngIf="networkConnection == true" class="fas icon setting-icon w-100 mr-0 ml-0"
                            [icon]="faLink"></fa-icon>
                          <fa-icon *ngIf="networkConnection == false" class="fas icon setting-icon w-100 mr-0 ml-0"
                            [icon]="faUnlink"></fa-icon>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 col-sm-3">
                      <div class="cursorPointer" *ngIf="projectOpen == true">
                        <div class="" type="button"
                          (click)="disableReadModeBtn != true && currentActiveUsers.length > 1 && openChatBoxModal();openChatPopup()">
                          <fa-icon *ngIf="chatUpdateColor == false" style="font-size: 17px !important"
                            class="far icon setting-icon w-100 mr-0 ml-0" [icon]="faComments"></fa-icon>
                          <fa-icon *ngIf="chatUpdateColor == true"
                            style="color: yellow !important; font-size: 17px !important;"
                            class="fa icon setting-icon w-100 mr-0 ml-0" [icon]="faComments"></fa-icon>
                          <span class='badge badge-light'
                            style="margin-left: 20px !important; margin-top: -38px !important;"
                            (click)="disableReadModeBtn != true && currentActiveUsers.length > 1 && openChatBoxModal();openChatPopup()"
                            id='activeUserCount'>{{currentActiveUsersCount}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 col-sm-3">
                      <div class="cursorPointer" type="button" *ngIf="projectOpen == true">
                        <fa-icon data-toggle="modal" data-target="#notifySection"
                          (click)="createActivity('No');notificationsComponent.getNotifications();notificationsComponent.getAllNotifications(0, loginDetails.registeredOn)"
                          class="far icon setting-icon w-100 mr-0 ml-0" [icon]="faBell"></fa-icon>
                        <span class='badge badge-light' id='unreadNotifications' data-toggle="modal"
                          data-target="#notifySection"
                          (click)="createActivity('No');notificationsComponent.getNotifications();notificationsComponent.getAllNotifications(0, loginDetails.registeredOn)">{{notificationsComponent.unreadNotificationCount}}</span>
                      </div>
                    </div>
                    <div class="col-3 col-sm-3">
                      <div class="cursorPointer" *ngIf="projectOpen == true">
                        <fa-icon data-toggle="modal" (click)="openMyNotes()"
                          class="fas icon setting-icon w-100 mr-0 ml-0" style="color: yellow !important;"
                          [icon]="faStickyNote"></fa-icon>
                        <!-- (click)="note.controller.switchNoteLayout(false);createActivity('Snt')" data-target="#myNote"-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-9 col-lg-9 col-sm-9 col-md-9 col-xs-8 p-0" *ngIf="projectOpen != true">
          <div class="row strict" >
            <label class="switch">
              <input type="checkbox" onChange="onFocusMode($event.target.checked)" [checked]="checkFocusMode()">
              <span class="slider round"></span>
            </label>
          </div>
        </div> -->
      </div>
    </nav>
    <div class="overlayLayer"></div>
    <!-- remaining design  -->
    <div id="mySidenav" class="sidenav text-color-black">
      <div class="sidebarProjectNameDiv">
        <h4 class="sidebarProjectName" *ngIf="projectOpen == true">
          [{{sessionProjectData.projectDetails.name}}]
        </h4>
        <a class="closebtn" (click)="closeNav()">&times;</a>
      </div>

      <!-- Collapse button -->

      <ul class="listStyleNone paddingleft0px" id="accordion1">

        <li *ngIf="projectOpen == true">
          <a class="navbar-toggler toggler-example" type="button" data-toggle="collapse" data-parent="#accordion1"
            data-target="#navbarSupportedContent1" aria-expanded="false">
            <span class="dark-blue-text">{{ 'menu.recon' | translate }}</span>
          </a>
          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent1">
            <!-- Links -->
            <ul class="navbar-nav mr-auto listStyleNone">
              <li class="nav-item" (click)="openTool('landscaper');createActivity('Ls');closeNav()"
                routerLink="/main/landscaper">

                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faMountain"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.landscape' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="openTool('personaMapperMindMap');createActivity('Pm');closeNav()"
                routerLink="/main/personaMapperMindMap"
                *ngIf="modelData.persona.length != 0 && modelData.listOfEUTs.length != 0">
                <!-- personaMapper.init();interactionMapper.init() -->
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faUser"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.personaMapper' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Pm')"
                *ngIf="modelData.persona.length == 0 || modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faUser"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.personaMapper' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item" (click)="openTool('interactionMapperMindMap');createActivity('Im');closeNav()"
                routerLink="/main/interactionMapperMindMap" *ngIf="modelData.listOfEUTs.length != 0">
                <!-- interactionMapper.init(); -->
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fab icon-black" [icon]="faConnectdevelop"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.interactionMapper' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Im')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fab icon-black" [icon]="faConnectdevelop"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.interactionMapper' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item" (click)="openTool('scopeMapperMindMap');createActivity('Sc');closeNav()"
                routerLink="/main/scopeMapperMindMap" *ngIf="modelData.listOfEUTs.length != 0">
                <!-- interactionMapper.init();scopeMapper.init(); -->
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faCubes"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.scopeMapper' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Sc')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faCubes"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.scopeMapper' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item" (click)="openTool('environmentMapper');createActivity('Ed');closeNav()"
                routerLink="/main/environmentMapper" *ngIf="modelData.listOfEnv.length != 0">

                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="far icon-black" [icon]="faObjectGroup"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.environmentMapper' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Ed')" *ngIf="modelData.listOfEnv.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="far icon-black" [icon]="faObjectGroup"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.environmentMapper' | translate }}
                    </div>
                  </div>
                </a>
              </li>

              <!-- <li class="nav-item" (click)="openTool('taskPlanner');createActivity('Tp1');closeNav()"
                routerLink="/main/taskPlanner" *ngIf="modelData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faTasks"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.taskPlanner' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Tp')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faTasks"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.taskPlanner' | translate }}
                    </div>
                  </div>
                </a>
              </li> -->
            </ul>
            <!-- Links -->
          </div>
        </li>
        <li *ngIf="projectOpen == true">
          <a class="navbar-toggler toggler-example" type="button" data-toggle="collapse" data-parent="#accordion1"
            data-target="#navbarSupportedContent2" aria-expanded="false">
            <span class="dark-blue-text">{{ 'menu.explore' | translate }}</span>
          </a>
          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent2">
            <!-- Links -->
            <ul class="navbar-nav mr-auto listStyleNone">
              <li class="nav-item" (click)="openTool('deepDive');createActivity('Dd');closeNav()"
                routerLink="/main/deepDive" *ngIf="modelData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faSkiing"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.deepdive' | translate }}
                  </div>
                </div>
              </li>

              <li class="nav-item" (click)="errorMsgPopup('Dd')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faSkiing"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.deepdive' | translate }}
                    </div>
                  </div>
                </a>
              </li>

              <li class="nav-item activityPage" (click)="openTool('testDesigner');createActivity('Td');closeNav()"
                routerLink="/main/testDesigner" *ngIf="sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faPenNib"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.designer' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Td')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faPenNib"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.designer' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item" (click)="openTool('checklist');createActivity('Cl');closeNav()"
                routerLink="/main/checklist">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faListOl"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.checklist' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="openTool('testExecutor');createActivity('Ex');closeNav()"
                routerLink="/main/testExecutor" *ngIf="sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faRunning"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.executor' | translate }}
                  </div>
                </div>
              </li>

              <li class="nav-item" (click)="errorMsgPopup('Ex')" *ngIf="modelData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faRunning"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.executor' | translate }}
                    </div>
                  </div>
                </a>
              </li>



              <li class="nav-item" (click)="openTool('testManager');createActivity('Tm');closeNav()"
                routerLink="/main/testManager"
                *ngIf="sessionProjectData.persona.length != 0 && sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faClipboardList"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.testmanager' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Tm')"
                *ngIf="sessionProjectData.persona.length == 0 || sessionProjectData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faClipboardList"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.testmanager' | translate }}
                    </div>
                  </div>
                </a>
              </li>
            </ul>
            <!-- Links -->
          </div>
        </li>
        <li *ngIf="projectOpen == true">
          <a class="navbar-toggler toggler-example" type="button" data-toggle="collapse" data-parent="#accordion1"
            data-target="#navbarSupportedContent3" aria-expanded="false">
            <span class="dark-blue-text">{{ 'menu.recoup' | translate }}</span>
          </a>
          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent3">
            <!-- Links -->
            <ul class="navbar-nav mr-auto listStyleNone">
              <li class="nav-item" (click)="openTool('dashboardTest');createActivity('Db');closeNav()"
                routerLink="/main/dashboardTest" *ngIf="sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faTh"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.testdashboard' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Db')" *ngIf="sessionProjectData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faTh"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.testdashboard' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <!-- <li class="nav-item" (click)="openTool('dashboardExecution');createActivity('Db');closeNav()"
                routerLink="/main/dashboardExecution" *ngIf="sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faTachometerAlt"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.execdashboard' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Db')" *ngIf="sessionProjectData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faTachometerAlt"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.execdashboard' | translate }}
                    </div>
                  </div>
                </a>
              </li>
              <li class="nav-item" (click)="openTool('dashboardQuality');createActivity('Db');closeNav()"
                routerLink="/main/dashboardQuality" *ngIf="sessionProjectData.listOfEUTs.length != 0">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fas icon-black" [icon]="faChartLine"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'menu.qtydashboard' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" (click)="errorMsgPopup('Db')" *ngIf="sessionProjectData.listOfEUTs.length == 0">
                <a class="navbar-toggler toggler-example emptyToolLinkMobile p-0" type="button" data-toggle="modal"
                  data-target="#EmptyDataPopup">
                  <div class="row strict">
                    <div class="col-xs-1 col-xs-offset-1">
                      <fa-icon class="fas icon-black" [icon]="faChartLine"></fa-icon>
                    </div>
                    <div class="col-xs-9 col-xs-offset-1">
                      {{ 'menu.qtydashboard' | translate }}
                    </div>
                  </div>
                </a>
              </li> -->
            </ul>
            <!-- Links -->
          </div>
        </li>
        <li>
          <a class="navbar-toggler toggler-example" type="button" data-toggle="collapse" data-parent="#accordion1"
            data-target="#navbarSupportedContent4" aria-expanded="false">
            <span class="dark-blue-text">{{ 'menu.settings' | translate }}</span>
          </a>
          <!-- Collapsible content -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent4">
            <!-- Links -->
            <ul class="navbar-nav mr-auto listStyleNone" id="accordion2">
              <li class="nav-item" type="button" data-toggle="modal" data-target="#switchProjectConfirm"
                data-parent="#accordion2" (click)="closeHamburgerMenu()" *ngIf="projectOpen == true">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faExchangeAlt"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.switchProject' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" type="button" data-toggle="modal" data-target="#downloadPopupModel"
                data-parent="#accordion2" (click)="openMenu('report')" *ngIf="projectOpen == true">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <!-- <i class="fa fa-floppy-o icon icon-black menu-icons" aria-hidden="true"></i> -->
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faSave"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.download' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" *ngIf="userrole == 0" type="button" data-toggle="collapse"
                data-target="#navbarSupportedContent5" aria-controls="navbarSupportedContent5" aria-expanded="false"
                data-parent="#accordion2" (click)="openMenu('orgmgmt')">
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faUsers"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.users' | translate }}
                  </div>
                </div>
                <div class="collapse navbar-collapse submenu" id="navbarSupportedContent5" *ngIf="menu.orgmgmt.show">
                  <ul class="navbar-nav mr-auto listStyleNone" id="accordion3">
                    <li class="nav-item">
                      <a class="navbar-toggler toggler-example pb-0 pt-0" type="button" data-toggle="modal"
                        data-target="#orgListPopupModel" data-parent="#accordion3"
                        (click)="getOrgUsers();closeHamburgerMenu()">
                        <label class="mb-0">{{ 'settings.userlist' | translate }}</label>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="navbar-toggler toggler-example pb-0 pt-0" type="button" data-toggle="modal"
                        data-target="#orgAddPopupModel" data-parent="#accordion3" (click)="closeHamburgerMenu()">
                        <label class="mb-0">{{ 'settings.adduser' | translate }}</label>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="navbar-toggler toggler-example pb-0 pt-0" type="button" data-toggle="modal"
                        data-target="#orgDeletePopupModel" data-parent="#accordion3"
                        (click)="getOrgUsers();closeHamburgerMenu()">
                        <label class="mb-0">{{ 'settings.deleteuser' | translate }}</label>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="navbar-toggler toggler-example pb-0 pt-0" type="button" data-toggle="modal"
                        data-target="#orgAdminChangePopupModel" data-parent="#accordion3"
                        [ngClass]="{ disabled: !disableLinks }" (click)="getOrgUsers();closeHamburgerMenu()">
                        <label class="mb-0">{{ 'settings.changeAdmin' | translate }}</label>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="nav-item" [ngClass]="{ disabled: !disableLinks }" type="button" data-toggle="modal"
                data-target="#projectMgmtPopupModel" data-parent="#accordion2"
                (click)='openMenu("projectmgmt");closeHamburgerMenu()'>
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faPencilAlt"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.projects' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" type="button" data-toggle="modal" data-target="#changePwdPopupModel"
                data-parent="#accordion2" (click)='closeHamburgerMenu()'>
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faKey"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.changePassword' | translate }}
                  </div>
                </div>
              </li>
              <li class="nav-item" type="button" data-toggle="modal" data-target="#feedbackPopupModel"
                data-parent="#accordion2" (click)='closeHamburgerMenu()'>
                <div class="row strict">
                  <div class="col-xs-1 col-xs-offset-1">
                    <fa-icon class="fa icon icon-black menu-icons" [icon]="faEnvelope"></fa-icon>
                  </div>
                  <div class="col-xs-9 col-xs-offset-1">
                    {{ 'settings.feedback' | translate }}
                  </div>
                </div>
              </li>
            </ul>
            <!-- Links -->
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="logout()">
            <fa-icon class="fa icon icon-black menu-icons" [icon]="faSignOutAlt"></fa-icon>
            <label class="setting-option-text-width">{{ 'settings.logout' | translate }}</label>
          </a>
        </li>
      </ul>
    </div>
    <div id="hamburgerMenu" tabindex="-1" class="modal left fade" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content square">
          <div class="modal-body">
            <ul class="nav flex-column">
              <li class="nav-item hoverredBlack"
                *ngIf="projectOpen == true && userrole == 0 && selectedProjectSource == 'Local'">
                <a class="nav-link" [ngClass]="{ disabled: !disableLinks }" data-toggle="modal"
                  data-target="#saveProjectPopupModel" (click)='closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black menu-icons" [icon]="faCloudDownloadAlt"></fa-icon>
                  <label class="setting-option-text-width">Save Project</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack" *ngIf="projectOpen == true">
                <a class="nav-link" data-toggle="modal" data-target="#switchProjectConfirm"
                  (click)="closeHamburgerMenu()">
                  <fa-icon class="fa icon icon-black" style="margin-right: 6px !important;"
                    [icon]="faExchangeAlt"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.switchProject' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack" *ngIf="projectOpen == true">
                <a class="nav-link" data-toggle="modal" (click)="openMenu('report')">
                  <fa-icon class="fa icon icon-black" style="margin-right: 8px !important;" [icon]="faSave"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.download' | translate }}</label>
                </a>
                <div class="project menu panel panel-primary" style="width: 152px !important;" *ngIf="menu.report.show">

                  <div class="panel-body">
                    <ul class="nav flex-column">

                      <li class="nav-item hoverredBlack">
                        <a class="nav-link"
                          (click)="getParamsToExport('projectSum');exportSelectedReport();closeHamburgerMenu()">
                          <label>Project summary</label>
                        </a>
                      </li>
                      <li class="nav-item hoverredBlack">
                        <a class="nav-link" data-toggle="modal" data-target="#entityReportPopupModel"
                          (click)="generateDownloadFileName()">
                          <label>Download scenarios</label>
                        </a>
                      </li>
                      <li class="nav-item hoverredBlack">
                        <a class="nav-link"
                          (click)="getParamsToExport('eutList');exportSelectedReport();closeHamburgerMenu()">
                          <label>Recon report</label>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>

              <li class="nav-item hoverredBlack" *ngIf="userrole == 0">
                <a class="nav-link" (click)="openMenu('orgmgmt')">
                  <fa-icon class="fa icon icon-black" style="margin-right: 4px !important;" [icon]="faUsers"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.users' | translate }}</label>
                </a>
                <div class="project menu panel panel-primary" *ngIf="menu.orgmgmt.show">

                  <div class="panel-body">
                    <ul class="nav flex-column">

                      <li class="nav-item hoverredBlack">
                        <a class="nav-link" (click)="getOrgUsers();closeHamburgerMenu()" data-toggle="modal"
                          data-target="#orgListPopupModel">
                          <label>{{ 'settings.userlist' | translate }}</label>
                        </a>
                      </li>
                      <li class="nav-item hoverredBlack">
                        <a class="nav-link" data-toggle="modal" data-target="#orgAddPopupModel"
                          (click)="closeHamburgerMenu()">
                          <label>{{ 'settings.adduser' | translate }}</label>
                        </a>
                      </li>
                      <li class="nav-item hoverredBlack">
                        <a class="nav-link" (click)="getOrgUsers();closeHamburgerMenu()" data-toggle="modal"
                          data-target="#orgDeletePopupModel">
                          <label>{{ 'settings.deleteuser' | translate }}</label>
                        </a>
                      </li>
                      <li class="nav-item hoverredBlack">
                        <a class="nav-link" (click)="getOrgUsers();closeHamburgerMenu()" data-toggle="modal"
                          data-target="#orgAdminChangePopupModel">
                          <label>{{ 'settings.changeAdmin' | translate }}</label>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" data-toggle="modal" data-target="#projectMgmtPopupModel"
                  (click)='openMenu("projectmgmt");closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black menu-icons" [icon]="faFile"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.projects' | translate }}</label>
                </a>
              </li>
              <!-- <li class="nav-item hoverredBlack dividerSetting" *ngIf="projectOpen == true && userrole == 0">
                <a class="nav-link" [ngClass]="{ disabled: !disableLinks }" data-toggle="modal"
                  data-target="#assistantSetupPopupModel" (click)='assistantModels();closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black" style="margin-right: 4px !important;" [icon]="faRobot"></fa-icon>
                  <label class="setting-option-text-width">Setup Assistant</label>
                </a>
              </li> -->
              <li class="nav-item hoverredBlack" *ngIf="projectOpen == true">
                <a class="nav-link" [ngClass]="{ disabled: !disableLinks }" data-toggle="modal"
                  data-target="#jiraLoginPopupModel" (click)='openMenu("jiralogin");closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black" style="margin-right: 8px !important;"
                    [icon]="faPencilAlt"></fa-icon>
                  <label class="setting-option-text-width">{{ 'jira.login' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" data-toggle="modal" data-target="#changePwdPopupModel"
                  (click)='closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black" style="margin-right: 7px !important;" [icon]="faKey"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.changePassword' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" data-toggle="modal" data-target="#feedbackPopupModel"
                  (click)="closeHamburgerMenu()">
                  <fa-icon class="fa icon icon-black" style="margin-right: 8px !important;"
                    [icon]="faEnvelope"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.feedback' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" data-toggle="modal" data-target="#tutorialsPopupModel"
                  (click)="tutorialProjects();closeHamburgerMenu()">
                  <fa-icon class="fa icon icon-black" style="margin-right: 7px !important;"
                    [icon]="faBookOpen"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.tutorials' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" (click)='openMoreInforPage();closeHamburgerMenu()'>
                  <fa-icon class="fa icon icon-black" style="margin-right: 8px !important;"
                    [icon]="faInfoCircle"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.learnMore' | translate }}</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" data-toggle="modal" data-target="#aboutToolModel" (click)="closeHamburgerMenu()">
                  <fa-icon class="fa icon icon-black" style="margin-right: 10px !important;" [icon]="faBook"></fa-icon>
                  <label class="setting-option-text-width">About</label>
                </a>
              </li>
              <li class="nav-item hoverredBlack">
                <a class="nav-link" (click)="logout();closeNav()">
                  <fa-icon class="fa icon icon-black" style="margin-right: 9px !important;"
                    [icon]="faSignOutAlt"></fa-icon>
                  <label class="setting-option-text-width">{{ 'settings.logout' | translate }}</label>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div id="userStatusToast">{{toastMsgUserStatus}}</div>

    <!-- The Modal -->
    <div class="modal fade" id="downloadPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body menuItemsClrBlack">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtnDwnMgmt">
                <button type="button" class="close" data-dismiss="modal" (click)="dwnldModalCancel()">&times;</button>
              </div>
              <div>
                <table class="table mb-0 downloadOptTable">
                  <tbody style="color: black !important;">
                    <tr>
                      <th class="borderNone" scope="row">Summary</th>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('projectSum')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">Project summary</span>
                        </label>
                      </td>

                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('designSum')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">Design summary</span>
                        </label>
                      </td>
                      <td class="borderNone"></td>
                    </tr>
                    <tr>
                      <th class="borderNone" scope="row">{{ 'settings.systemInfo' | translate }}</th>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('eutList')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.userList' | translate }}</span>
                        </label>
                      </td>

                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('maps')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.maps' | translate }}</span>
                        </label>
                      </td>
                      <td class="borderNone"></td>
                    </tr>
                    <tr>
                      <th class="borderNone" scope="row">{{ 'settings.scenarios' | translate }}</th>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" class="custom-control-input"
                            (click)="addScenarioEntityType('TF')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.features' | translate }}</span>
                        </label>
                      </td>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="addScenarioEntityType('UR')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.requirements' | translate }}</span>
                        </label>
                      </td>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="addScenarioEntityType('BF')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.flows' | translate }}</span>
                        </label>
                      </td>
                    </tr>
                    <tr>
                      <th class="borderNone" scope="row"></th>
                      <td class="borderNone">
                        <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('suites')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.suites' | translate }}</span>
                        </label>
                      </td>
                      <td class="borderNone"> <label class="exportLable custom-control custom-checkbox">
                          <input type="checkbox" class="custom-control-input" (click)="getParamsToExport('summary')">
                          <span class="custom-control-indicator"></span>
                          <span class="marginleft10px">{{ 'settings.summary' | translate }}</span>
                        </label></td>
                      <td class="borderNone"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary modalActionBtn marginleftright10per floatleft minwidth75px"
                (click)="exportSelectedReport();closeNav()" data-dismiss="modal">{{ 'ok' | translate }}</button>
              <button type="button"
                class="btn btn-secondary modalActionBtn marginleftright10per floatright minwidth75px "
                data-dismiss="modal" (click)="dwnldModalCancel()">{{ 'cancel' | translate }}</button>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- The Org List Modal -->
    <div class="modal fade" id="orgListPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body menuItemsClrBlack">
              <table class="table table-borderless table-dark orgListOptTable cursorArrow">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">{{ 'settings.username' | translate }}</th>
                    <th scope="col">{{ 'settings.firstname' | translate }}</th>
                    <th scope="col">{{ 'settings.role' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let user of orgUserList| sortArray:'userrole'; let tabIndex = index">
                    <th scope="row">{{tabIndex+1}}</th>
                    <td>{{user.username}}</td>
                    <td>{{user.firstname}}</td>
                    <td *ngIf="user.userrole == 0">{{ 'settings.admin' | translate }}</td>
                    <td *ngIf="user.userrole == 1">{{ 'settings.user' | translate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                data-dismiss="modal">{{ 'ok' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Org Add User Modal -->
    <div class="modal fade" id="orgAddPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal" (click)="emptyInviteField()">&times;</button>
                </div>
                <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
                  <div class="form-element mb-0">
                    <label for="lastname"
                      class="form-label marginbottom6px displayNone">{{'group.email'|translate}}</label>
                    <div class="form-element-input">
                      <input type="text" id="inviteMailId" name="inviteMailId"
                        class="form-input-feild input-sm menuItemsClrBlack" value="" [(ngModel)]="inviteMailId"
                        [placeholder]="'group.userEmail'| translate" required>
                    </div>
                  </div>
                </div>
                <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
                  <div class="form-element">
                    <!-- <label class="form-label"></label> -->
                    <div class="form-element-input inviteFormElement">
                      <button type="button" class="btn btn-secondary userInvitetoOrgBtn actionbutton pl-0 pr-0"
                        (click)="checkUserExistsinSystem(inviteMailId);closeNav()">{{'settings.invite'|translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>



    <!-- The Org Add User Invitation succesfull message Modal -->
    <div class="modal fade" id="orgAddSuccessPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element">
                    <label class="form-label">{{inviteMessage}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Switching Project Confirm Message Modal -->
    <div class="modal fade" id="orgAddUserConfirmPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{inviteMessage}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="addUserToOrg(inviteMailId);closeNav()">{{ 'yes' | translate }}</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{ 'no' | translate
                }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Org Delete User Modal -->
    <div class="modal fade" id="orgDeletePopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
                  <div class="form-element mb-0">
                    <label class="form-label marginbottom6px displayNone">{{'settings.selectUser'|translate}}</label>
                    <select class="form-control form-input-feild height29px menuItemsClrBlack"
                      [(ngModel)]="selectToRemoveUsr" placeholder="'settings.chooseUser'| translate"
                      [disabled]="orgUserList.length == 1">
                      <option value="" disabled selected hidden>{{'settings.chooseUser'|translate}}</option>
                      <option [ngClass]="{displayNone:user.userrole == 0}" value="{{user._id}}"
                        *ngFor="let user of orgUserList; let tabIndex = index">
                        {{user.username}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
                  <div class="form-element">
                    <div class="form-element-input removeFormElement">
                      <button type="button" name="remove_orgUsers"
                        (click)="openRemoveOrgConfirmPopup(selectToRemoveUsr)"
                        class="btn btn-secondary userInvitetoOrgBtn removeUserBtn actionbutton pr-0 pl-0">{{'settings.remove'|translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Org Delete User Confirm Message Modal -->
    <div class="modal fade" id="orgDeletePopupModelConfirm" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{'settings.removeuser'|translate}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="selectUsrToRemoveFromOrg(selectToRemoveUsr);closeNav()">{{ 'yes' | translate }}</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'no' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Org Delete User success Message Modal -->
    <div class="modal fade" id="orgUserDeleteSuccessPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{userDeleteMessage}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- The Org admin change Modal -->
    <div class="modal fade" id="orgAdminChangePopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-8 col-md-8 col-lg-8 col-sm-8 col-xs-8">
                  <div class="form-element mb-0">
                    <label class="form-label marginbottom6px displayNone">{{'settings.selectUser'|translate}}</label>
                    <select class="form-control form-input-feild height29px menuItemsClrBlack" [(ngModel)]="selectAdmin"
                      placeholder="'settings.chooseUser'| translate" [disabled]="orgUserList.length == 1">

                      <option value="" disabled selected hidden>{{'settings.chooseUser'|translate}}</option>
                      <option [ngClass]="{displayNone:user.userrole == 0}" value="{{user._id}}"
                        *ngFor="let user of orgUserList; let tabIndex = index">
                        {{user.username}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col col-4 col-md-4 col-lg-4 col-sm-4 col-xs-4">
                  <div class="form-element">
                    <div class="form-element-input removeFormElement">
                      <button type="button" name="changeOrgAdmin" (click)="changeAdminConfirmPopupOpen(selectAdmin)"
                        class="btn btn-secondary userInvitetoOrgBtn removeUserBtn actionbutton">{{'settings.makeadmin'|translate}}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Org Admin Confirm Message Modal -->
    <div class="modal fade" id="orgAdminChangePopupModelConfirm" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">
                      {{'settings.doyouchangeadmin'|translate}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="selectUsrToMakeAdmin(selectAdmin);closeNav()">{{ 'yes' | translate }}</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'no' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Project management Modal -->
    <div class="modal fade" id="projectMgmtPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content projectMgmtModelHt">
            <div class="modal-header p-1 pr-4 pl-4">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <div class="modal-title text-color-black cursorArrow">{{'settings.managepro'|translate}}</div>
            </div>
            <!-- Modal body -->
            <div class="modal-body menuItemsClrBlack project-manage-modal-body-height">
              <div class="row strict h-100">
                <div class="row strict h-100">
                  <div class="col col-5 col-md-5 col-lg-5 col-sm-5 col-xs-5 h-100 padding5px">
                    <div class="mb-0 mt-0">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              <span>
                                {{selectedApplication.name || 'selectApp' | translate}}
                              </span>
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-100 scrollable-menu">
                          <li class="row padding-vertical pl-2 pr-2" *ngFor="let app of applicationsList"
                            (click)="chooseApplication(app)">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                              {{app.name}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-account mb-0 mt-0">
                      <input type="text" class="form-input-feild input-sm margintop1px marginbottom1px"
                        [(ngModel)]="currProjectInPrjMgmt" list="myProjectsMgmt"
                        (ngModelChange)="manageSelectedProjectFromDL(currProjectInPrjMgmt)"
                        [placeholder]="'projectSearch'| translate" autocomplete="off" required>
                      <datalist class="cursorPointer" id="myProjectsMgmt">
                        <option *ngFor="let project of projectsMgmtList; let tabIndex = index">
                          <!-- *ngIf="projects.length != 0 && project.projectDetails.name != 'Demo app'" -->
                          {{project.projectDetails.name}}
                        </option>
                        <option *ngIf="projects.length == 0">{{ 'noProjectsCreated' | translate }}
                        </option>
                      </datalist>
                    </div>
                    <div class="table-bordered overflowYTextAuto project-manage-modal-projects-list-table-height">
                      <table class="table table-bordered-bottom env ui-sort-per mb-0 projectsManageModalTable"
                        id="myProjectsMgmtTable">
                        <tbody class="tableBackgrdClrBlack">
                          <tr class="ui-sortable-item strict clickable-row" [class.active]="tabIndex == HighlightRow"
                            *ngFor="let project of projectsMgmtList; let tabIndex = index"
                            (click)="manageSelectedProject(project);ClickedRow(tabIndex)"
                            [ngClass]="{displayNone:(((projects.length == 0)||(project.projectDetails.name == 'Demo app')))}">
                            <td class="col-xs-12">
                              <label class="form-control transparent"
                                [textContent]="project.projectDetails.name"></label>
                            </td>
                          </tr>
                          <tr *ngIf="projects.length == 0">
                            <td class="no-padding">
                              <button class="btn btn-default btn-block btn-xs">
                                <span>{{ 'noProjectsCreated' | translate }}</span>
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div class="col col-5 col-md-5 col-lg-5 col-sm-5 col-xs-5 h-100 padding5px">
                    <textarea class="form-control table-bordered" rows="1" [(ngModel)]="currProject.projectDetails.name"
                      [placeholder]="'phNewMenuName'| translate">
                      </textarea>
                    <textarea class="form-control table-bordered" rows="3"
                      [(ngModel)]="currProject.projectDetails.description"
                      [placeholder]="'phNewDescription'| translate">
                      </textarea>
                    <div
                      class="table-bordered table-bordered-bottom overflowYTextAuto project-manage-modal-projects-users-list-height projectUsersListTable">
                      <ul class="list-inline">
                        <li class="list-inline-item border-bottom1px w-98"
                          *ngFor="let user of orgUserListByProject; let tabIndex = index">
                          <label class="exportLable custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input cursorPointer"
                              (click)="selectAddUser(user,$event.target.checked)"
                              [checked]="projectUserListIds.indexOf(user._id) > -1" [disabled]="myUserID==user._id">
                            <span class="custom-control-indicator"></span>
                            <span class="marginleft10px">{{user.username}}
                              ({{user.firstname}})</span>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2 h-100 padding5px">
                    <div class="align_right">
                      <button type="button" class="btn btn-secondary modalActionBtn minwidth75px mb-2"
                        (click)="checkProjectUserUpdate(projectUserList,projectUserListIds)">
                        {{ 'save' | translate }}
                      </button>
                      <button type="button" class="btn btn-secondary modalActionBtn minwidth75px" data-dismiss="modal"
                        (click)="dwnldModalCancel()">{{ 'cancel' | translate }}</button>
                    </div>
                    <div class="project-manage-modal-projects-buttons-gap-height projectModalGapDiv1"></div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="projectModalGapDiv2">&nbsp;</div>
                    <div class="align_right">
                      <button type="button" class="btn btn-secondary modalActionBtn minwidth75px"
                        (click)="exportJSON();closeNav()">{{ 'export' | translate }}</button>
                    </div>
                  </div>
                </div>
                <div id="changePwdMessage">
                  <div class="text-message text-color-black">{{toastMsg}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The chatting popup Modal -->
    <div class="modal fade" id="chatPopupModal" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center height300px">
          <div class="modal-content">
            <div class="modal-header p-1 pr-4 pl-4">
              <button type="button" class="close" data-dismiss="modal" (click)="openChatPopup()">
                &times;
              </button>
              <div class="modal-title text-color-black">{{'settings.chatBox'|translate}}</div>
            </div>
            <!-- Modal body -->
            <div class="modal-body menuItemsClrBlack chatbox-modal-body-height pb-2">
              <div class="row strict h-100">
                <div class="row strict chatbox-modal-chat-upper-section-msgs-list-height pb-2">
                  <div class="table-bordered table-bordered-bottom overflowYTextAuto chatMessageListTable h-100">
                    <ul class="list-inline chatUList">
                      <li class="list-inline-item border-bottom1px w-100 ml-0 mr-0 pr-3 pl-3"
                        *ngIf="chatMessages.length == 0">
                        <span class="text-align-justify">{{'settings.noMsgs' | translate}}</span>
                      </li>
                      <li class="list-inline-item border-bottom1px w-100 ml-0 mr-0 pr-3 pl-3"
                        *ngFor="let msg of chatMessages; let tabIndex = index">
                        <span class="text-align-justify" *ngIf="msg.fromId != myUserID">
                          ({{msg.fromUser}}) {{msg.message}}
                        </span>
                        <span class="text-align-justify" *ngIf="msg.fromId == myUserID">
                          {{msg.message}}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="row strict">
                  <div class="row strict h-100">
                    <div class="row strict chatbox-modal-chat-textarea-height pb-2">
                      <div class="col-12 col-sm-12 col-md-12">
                        <textarea class="form-control table-bordered mb-0" rows="3" [(ngModel)]="messageContent"
                          [placeholder]="'settings.enterMessage'| translate"
                          (keyup.enter)="sendMessage(messageContent)">
                      </textarea>
                      </div>
                    </div>
                    <div class="row strict">
                      <div class="col-2 col-sm-2 col-md-2 pr-2">
                        <div class="text-align-center pb-1 pt-1 msgSendBtn">
                          To:
                        </div>
                      </div>
                      <div class="col-8 col-sm-8 col-md-8 pr-2">
                        <div class="dropdown">
                          <button
                            class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                            type="button" data-toggle="dropdown">
                            <div class="row strict">
                              <div class="col-xs-7 span-on-button ">
                                <span *ngIf="dropdownTitle == true">{{'settings.everyone' | translate}}</span>
                                <span *ngIf="dropdownTitle == false">{{'settings.individual' | translate}}</span>
                              </div>
                              <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                                <span class="caret"></span>
                              </div>
                            </div>
                          </button>
                          <ul class="dropdown-menu text-color-black w-100">

                            <li class="row padding-vertical" [ngClass]="{displayNone:user.userId == myUserID}"
                              *ngFor="let user of currentActiveUsers; let tabIndex = index">
                              <div class="col-xs-2 col-sm-2 col-md-2 col-lg-1 col-xl-1">
                                <div style="text-align: center;">
                                  <input class="checkboxReadOnly chatUsersCheckbox"
                                    (click)="addUserToChatbox(user,$event.target.checked)" type="checkbox">
                                </div>
                              </div>
                              <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item">
                                {{user.username}}
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-2 col-sm-2 col-md-2">
                        <button type="button" class="btn btn-secondary modalActionBtn w-100 pt-1 pb-1 msgSendBtn"
                          (click)="sendMessage(messageContent)"
                          [ngClass]="{ dis:messageContent==0}">{{'settings.sendBtn' | translate}}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Switching Project Confirm Message Modal -->
    <div class="modal fade" id="switchProjectConfirm" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{ 'changeProject' | translate }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="openMenu('switch');closeNav()" routerLink="/main/projectselect">
                {{ 'yes' | translate }}
              </button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'no' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- The Switching Project Confirm Message Modal -->
    <div class="modal fade" id="aboutToolModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px"> <img class="logo bg-color-black"
                        src="./assets/images/stag_logo.png" alt="logo"></label><br>
                    <label class="form-label marginbottom6px"><b>Enterprise Edition:
                        1.0.0</b></label><br>
                    <label class="form-label marginbottom6px"><b><a
                          href="http://stagsoftware.com/dosmartqa-privacy-policy/" target="_blank">Privacy
                          policy</a></b></label><br><br>
                    <label class="form-label marginbottom6px"><b>&#169; 2024, STAG Software Pvt
                        Ltd</b></label><br>
                    <label class="form-label marginbottom6px"><b><a href="https://stagsoftware.com"
                          target="_blank">https://stagsoftware.com</a></b></label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
          </div>
        </div>
      </div>
    </div>
    <!-- The change password warning message modal -->
    <div class="modal fade" id="changePwdPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{ 'changePwdWarning' | translate }}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="changePwdContinue()" data-dismiss="modal">
                {{ 'continue' | translate }}
              </button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The change password form modal -->
    <div class="modal fade" id="changePwdFormPopupModal" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <form novalidate (ngSubmit)="changePasswordFormSubmit(changepwd)" method="post"
                    id="change-password-form" class="form-group">
                    <div class="form-header title text-align-center text-color-black">{{ 'changePassword' | translate }}
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="password" name="oldpassword" id="oldpassword"
                          class="form-input-feild text-color-black" value="" [(ngModel)]="changepwd.oldpassword"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'presentPassword'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="password" name="newpassword" id="newpassword"
                          class="form-input-feild text-color-black" value="" [(ngModel)]="changepwd.newpassword"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'newPassword'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="password" name="confirmpassword" id="confirmpassword"
                          class="form-input-feild text-color-black" value="" [(ngModel)]="changepwd.confirmpassword"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'newPasswordConfirm'| translate"
                          required>
                      </div>
                    </div>
                    <div>
                      <div class="text-message text-color-black" [innerHTML]="changePwdMessage">--</div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="changePasswordFormSubmit(changepwd)">{{ 'changePasswordBtn' | translate }}</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">{{ 'cancel' |
                translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Jira login form modal -->
    <div class="modal fade" id="jiraLoginPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <form novalidate (ngSubmit)="jiraLoginFormSubmit(jiraLogin)" method="post" id="jira-login-form"
                    class="form-group">
                    <div class="form-header title text-align-center text-color-black cursorArrow">
                      {{ 'jira.loginTitle' | translate }}
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="text" name="jiraurl" id="jiraurl" class="form-input-feild text-color-black"
                          value="" [(ngModel)]="jiraLogin.jiraurl" [ngModelOptions]="{standalone: true}"
                          [placeholder]="'jira.URL'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="text" name="jirausername" id="jirausername"
                          class="form-input-feild text-color-black" value="" [(ngModel)]="jiraLogin.username"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'jira.username'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="password" name="jirapassword" id="jirapassword"
                          class="form-input-feild text-color-black" value="" [(ngModel)]="jiraLogin.password"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'jira.password'| translate" required>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" (click)="jiraLoginFormSubmit(jiraLogin)">
                {{ 'jira.loginbtn' | translate }}
              </button>
            </div>

            <!-- Modal body -->
            <div class="modal-body" *ngIf="showJiraprojectList">
              <div class="row pb-0">
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="row strict">
                    <!-- <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 pr-2">
                      <div class="dropdown">
                        <button
                          class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                          type="button" data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-7 span-on-button ">
                              <span>
                                {{selectedDoSmartQAProject.projectDetails.name || 'jira.selectProject' | translate}}
                              </span>
                            </div>
                            <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu text-color-black w-100 scrollable-menu">
                          <li class="row padding-vertical pl-2 pr-2"
                            *ngFor="let pro of doSmartQAProjectList; let tabIndex = index"
                            (click)="selectDoSmartQAProject(pro)"
                            [ngClass]="{displayNone:(pro.projectDetails.name == 'Demo app')}">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                              {{pro.projectDetails.name}}
                              <span *ngIf="pro.jiraProjectDetails.id != ''">
                                (Linked: {{pro.jiraProjectDetails.name}})
                              </span>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div> -->
                    <!-- <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 pl-2"> -->
                    <div class="dropdown">
                      <button
                        class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                        type="button" data-toggle="dropdown">
                        <div class="row strict">
                          <div class="col-xs-7 span-on-button ">
                            <span>
                              {{selectedJiraProject.name || 'jira.selectProject' | translate}}
                            </span>
                          </div>
                          <div class="col-xs-2 col-sm-2 col-lg-2 col-md-2 col-xs-offset-1 pull-right ">
                            <span class="caret"></span>
                          </div>
                        </div>
                      </button>
                      <ul class="dropdown-menu text-color-black w-100 scrollable-menu">
                        <li class="row padding-vertical pl-2 pr-2"
                          *ngFor="let pro of jiraProjectList; let tabIndex = index" (click)="selectJiraProject(pro)">
                          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item">
                            {{pro.name}}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
              <div class="row" id="changePwdMessage">
                <div class="text-message text-color-black">{{toastMsg}}</div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center" *ngIf="showJiraprojectList">
              <button *ngIf="sessionProjectData.jiraProjectDetails.name == ''" type="button"
                class="btn btn-secondary modalActionBtn"
                (click)="linkJiraProjectWithDoSmartQAproject(selectedDoSmartQAProject, selectedJiraProject)">
                {{ 'jira.linkBtn' | translate }}
              </button>
              <button *ngIf="sessionProjectData.jiraProjectDetails.name != ''" type="button"
                class="btn btn-secondary modalActionBtn"
                (click)="unLinkJiraProjectWithDoSmartQAproject(selectedDoSmartQAProject, selectedJiraProject)">
                {{ 'jira.unlinkBtn' | translate }}
              </button>
              <div class="row" id="jiraUpdateToast">
                <div class="col text-message text-color-black">
                  {{toastMsg}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Intelligent assistant setup modal -->
    <div class="modal fade" id="assistantSetupPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <form novalidate id="intelligent-assistant-form" class="form-group">
                    <div class="form-header title text-align-center text-color-black cursorArrow">OpenAI Intelligent Assistant Setup
                    </div>
                    <div class="form-element mb-0">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle" type="button"
                          data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button">
                              <span *ngIf="selectedAssistantModel==''">Choose OpenAI model</span>
                              <span title="{{selectedAssistantModel}}"
                                *ngIf="selectedAssistantModel!=''">{{selectedAssistantModel}}</span>
                            </div>
                            <div class="col-xs-1 pull-right">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu w-100">
                          <li class="row strict text-color-black" *ngFor="let model of assistantModelsList">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item"
                              (click)="selectAssistantModel(model.model)" style="padding-left: 4px;">
                              {{model.model}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="password" name="token" id="token" class="form-input-feild text-color-black"
                          value="" [(ngModel)]="assistantSetup.token" (ngModelChange)="assistantChanges()"
                          [ngModelOptions]="{standalone: true}" [placeholder]="'AssistantToken'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="form-element-input">
                        <input type="number" min="400" name="maxtokens" id="maxtokens"
                          class="form-input-feild text-color-black" title="Maxtokens (Above 500)"
                          [(ngModel)]="assistantSetup.maxtokens" [ngModelOptions]="{standalone: true}"
                          [placeholder]="'AssistantUserName'| translate" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="text-message text-color-black">{{toastMsg}}</div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" *ngIf="validateAPIKey == false" class="btn btn-secondary modalActionBtn"
                (click)="validateApiKey(assistantSetup)">Validate API Key</button>
              <button type="button" *ngIf="validateAPIKey == true"
                class="btn btn-secondary modalActionBtn marginright10per"
                (click)="assistantSetupFormSubmit(assistantSetup)">{{ 'save' |
                translate }}</button>
              <button type="button" *ngIf="validateAPIKey == true" class="btn btn-secondary modalActionBtn"
                data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The Intelligent assistant setup modal -->
    <div class="modal fade" id="saveProjectPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <form novalidate id="save-project-form" class="form-group">
                    <div class="form-header title text-align-center text-color-black">Save Project
                    </div>
                    <div class="form-element mb-0">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle" type="button"
                          data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button">
                              <span *ngIf="selectedProjectSaveLocation==''">Please choose</span>
                              <span title="{{selectedProjectSaveLocation}}"
                                *ngIf="selectedProjectSaveLocation!=''">{{selectedProjectSaveLocation}}</span>
                            </div>
                            <div class="col-xs-1 pull-right">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu w-100">
                          <li class="row strict text-color-black" *ngFor="let model of Config.projectSaveLocations">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item"
                              (click)="selectProjectSavelocation(model)" style="padding-left: 4px;">
                              {{model}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- <div class="form-element mb-0" style="margin-top: 2%;">
                     
                      <div class="file-upload form-account m-0">
                        <div class="file-select" style="border: 1px solid black;">
                          <div class="file-select-button" id="fileName">{{ 'choosefile' | translate }}</div>
                          <div class="file-select-name" *ngIf="!uploadFileName" id="noFile">{{ 'nofilechoosen' |
                            translate
                            }}</div>
                          <div class="file-select-name" *ngIf="uploadFileName" id="noFile">{{ uploadFileName}}</div>
                          <input class="form-input-feild p-0 mt-0 mb-0" type="file" name="chooseFile" id="chooseFile"
                            accept=".json,application/json" (change)="showContent($event)">
                        </div>
                      </div>
                    </div> -->

                    <div class="form-element mb-0">
                      <div class="text-message text-color-black">{{toastMsg}}</div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">

              <button type="button" class="btn btn-secondary modalActionBtn marginright10per">{{ 'save' |
                translate }}</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The feedback modal -->
    <div class="modal fade" id="feedbackPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content feedbackModalHtWd">
            <!-- <div class="col-sm-2 col-md-2 col-xs-3 col-xl-2 col-lg-2 pl-0 pr-0">
              <div class="form-group">
                <div class="col-sm-12 col-md-12 col-xs-12 col-xl-12 col-lg-12 pl-0 pr-0">
                  <select id="feedbackMethod" [(ngModel)]="feedbackMethod" class="btn selectButton w-auto custom-font-family">
                    <option [value]="Suggestion">Suggestion</option>
                    <option [value]="Issue">Issue</option>
                  </select>
                </div>
              </div>
            </div> -->
            <!-- <div class="col-sm-10 col-md-10 col-xs-9 col-xl-10 col-lg-10 pl-2 pr-2">
              <input type="text" class="form-control custom-font-family subjectInputField" [(ngModel)]="feedbackSubject" 
                [placeholder]="Enter subject">
            </div> -->
            <div class="modal-header p-1 pr-4 pl-4">
              <button type="button" class="close" data-dismiss="modal">
                &times;
              </button>
              <h4 class="modal-title text-color-black cursorArrow">{{'settings.myfeedback'|translate}}</h4>
            </div>
            <!-- Modal body -->
            <div class="modal-body menuItemsClrBlack feedback-quill-content-height">
              <div class="row strict h-100">
                <div class="row strict h-100">
                  <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12 h-100">
                    <div class="h-100" id="feedbackQuillCSS">
                      <quill-editor [(ngModel)]="feedbackEditorContent">
                        <div quill-editor-toolbar>
                          <span class="ql-formats">
                            <select class="ql-header"></select>
                            <button class="ql-bold" [title]="'Bold'"></button>
                            <button class="ql-italic" [title]="'Italic'"></button>
                            <button class="ql-underline" [title]="'Underline'"></button>
                            <button class="ql-list" value="ordered"></button>
                            <button class="ql-list" value="bullet"></button>
                            <!-- <button class="ql-image" [title]="'Image'"></button> -->
                            <button class="ql-code" [title]="'Code'"></button>
                          </span>
                        </div>
                      </quill-editor>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div class="row full-width pl-4 pr-4">
                <div class="col-sm-3 col-md-3 col-xs-3 col-xl-3 col-lg-3 pl-2 pr-2">
                  <div class="file-upload form-account m-0">
                    <div class="file-select">
                      <div class="file-select-button custom-font-family" id="fileName">Choose file</div>
                      <div class="file-select-name custom-font-family" id="noFileImage">No file chosen</div>
                      <input class="form-input-feild p-0 mt-0 mb-0" type="file" name="chooseFileImage"
                        id="chooseFileImage" (change)="choosenImage($event)">
                    </div>
                  </div>
                </div>
                <div class="col-sm-3 col-md-3 col-xs-3 col-xl-3 col-lg-3 pl-2 pr-2">
                  <!-- <div class="custom-font-family" style="color: black !important;"></div> -->
                </div>
                <div class="col-sm-4 col-md-4 col-xs-4 col-xl-5 col-lg-4 pl-2 pr-2">
                  <!-- [innerHTML]="feedbackErrorMessage" -->
                  <div class="custom-font-family" style="color: black !important;"></div>
                </div>
                <div class="col-sm-2 col-md-2 col-xs-2 col-xl-1 col-lg-2 float-right pr-0 pl-0">
                  <button type="button" (click)="sendFeedback()"
                    class="btn btn-secondary submitBtn custom-font-family text-color-black float-right">
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The empty data popup modal -->
    <div class="modal fade" id="EmptyDataPopup" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{noDataPopupMsg}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">

              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'ok' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The error messsages in create project popup modal -->
    <div class="modal fade" id="errorMessagePopup" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{toastMsg}}</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'ok' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The change project users confirm message modal -->
    <div class="modal fade" id="projectUsersUpdateConfirmPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label *ngIf="delProUsers.length == 1" class="form-label marginbottom6px">
                      {{ 'updateProjectSingleUser' | translate }}&nbsp;{{delProUsers[0].username}}?
                    </label>
                    <label *ngIf="delProUsers.length > 1" class="form-label marginbottom6px">
                      {{ 'updateProjectMultipleUsers' | translate }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="projectUsersUpdate(projectUserListIds);hideProjectMgmtModal()" data-dismiss="modal">
                {{ 'yes' | translate }}
              </button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'no' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The change project users active error message modal -->
    <div class="modal fade" id="projectUsersUpdateErrorPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label *ngIf="activeUsersDetails.length == 1" class="form-label marginbottom6px">
                      {{activeUsersNames}}&nbsp;{{'activeUserRemoveErr'| translate}}
                    </label>
                    <label *ngIf="activeUsersDetails.length > 1" class="form-label marginbottom6px">
                      {{activeUsersNames}}&nbsp;{{'activeUsersRemoveErr'| translate}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">
                {{ 'ok' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- The scenario duplicate error message modal -->
    <div class="modal fade" id="duplicateScenarioErrorPopupModelDesigner" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{testDesigner.model.duplicateScenario}}</label>
                  </div>
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{testDesigner.model.errorMessage}}</label>
                  </div>
                  <div class="form-element text-align-center">
                    <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                      data-dismiss="modal">{{ 'ok' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The scenario duplicate error message modal -->
    <div class="modal fade" id="duplicateScenarioErrorPopupModelExecutor" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{validator.controller.duplicateScenario}}</label>
                  </div>
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{validator.controller.errorMessage}}</label>
                  </div>
                  <div class="form-element text-align-center">
                    <button type="button" class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0"
                      data-dismiss="modal">{{ 'ok' | translate }}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Tutorials modal -->
    <div class="modal fade" id="tutorialsPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content" style="max-width: 400px !important;">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div id="intelligent-assistant-form" class="form-group">
                    <div class="form-header title text-align-center text-color-black cursorArrow">
                      Tutorials
                    </div>
                    <p class="cursorArrow text-color-black">These tutorials explain specific aspects of HyBIST as
                      implemented in doSmartQA.
                    </p>
                    <div class="form-element mb-0">
                      <div class="dropdown">
                        <button class="btn btn-default btn-sm btn-block dropdown-toggle" type="button"
                          data-toggle="dropdown">
                          <div class="row strict">
                            <div class="col-xs-11 span-on-button">
                              <span *ngIf="selectedTutorialName==''">Choose Tutorial</span>
                              <span title="{{selectedTutorialName}}"
                                *ngIf="selectedTutorialName!=''">{{selectedTutorialName}}</span>
                            </div>
                            <div class="col-xs-1 pull-right">
                              <span class="caret"></span>
                            </div>
                          </div>
                        </button>
                        <ul class="dropdown-menu w-100">
                          <li class="row strict text-color-black cursorPointer" *ngFor="let model of tutorialsProjects">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 dropdown-item"
                              style="padding-left: 4px;" (click)="selectTutorial(model.projectDetails,model._id)">
                              {{model.projectDetails.name}}
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <label class="mb-0 mt-2 text-color-black">Description :</label>
                      <div class="form-element-input mt-0">
                        <textarea type="text" style="height: 135px !important; overflow: auto;" name="token" id="token"
                          rows="9" class="form-input-feild text-color-black cursorArrow" value=""
                          [(ngModel)]="selectedTutorialProject.description" placeholder="Description"
                          [ngModelOptions]="{standalone: true}" readonly></textarea>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="text-message text-color-black">{{toastMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" (click)="downloadTutorial()"
                class="btn btn-secondary modalActionBtn">Download</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The Entity report modal -->
    <div class="modal fade" id="entityReportPopupModel" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
                <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                  <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div id="save-project-form" class="form-group">
                    <div class="form-header title text-align-center text-color-black cursorArrow">
                      Scenarios Report
                    </div>
                    <div class="form-element mb-0">
                      <label class="text-color-black">File name :</label>
                      <div class="form-element-input">
                        <input style="margin-top: 0px !important;" type="text" min="400" name="reportName"
                          id="reportName" class="form-input-feild text-color-black" title="File name"
                          [(ngModel)]="CSVdownloadFileName" placeholder="File name" required>
                      </div>
                    </div>
                    <div class="form-element mb-0">
                      <div class="text-message text-color-black">{{toastMsg}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn marginright10per"
                (click)="generateScenariosReport()">Download</button>
              <button type="button" class="btn btn-secondary modalActionBtn" data-dismiss="modal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- The welcome note popup modal -->
    <div class="modal fade" id="welcomeNotePopup" data-backdrop="">
      <div class="vertical-alignment-helper">
        <div class="modal-dialog vertical-align-center">
          <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body">
              <div class="row pb-0">
                <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div class="form-element text-align-center">
                    <label class="form-label marginbottom6px">{{ 'hi' | translate }}&nbsp;{{userDisplayName}},
                      <div style="white-space: pre">
                        {{ 'welcomeNoteText' | translate }} <br>
                        {{ 'welcomeNoteText1' | translate }}
                      </div>
                      <!-- </br> -->
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer text-align-center">
              <button type="button" class="btn btn-secondary modalActionBtn" (click)="welcomeNoteClose()">
                {{ 'continue' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- remaining design close -->
  </header>

  <section class="main-section session-view-height">
    <div id="readonlyOverLay" class=""></div>
    <div class="row strict h-99point5">
      <div class="session-view-height" *ngIf="currentView == 'projectSelect'">
        <app-projectselect></app-projectselect>
      </div>
      <div class="col-sm-3 h-100" *ngIf="projectOpen == true && myNotesOpen == false && chatGPTOpen == false">
        <div class="no-gutter h-100" *ngIf="focusMode == true">
          <app-entity-test-coverage></app-entity-test-coverage>
        </div>
        <div class="no-gutter h-100" *ngIf="focusMode == false">
          <app-planner></app-planner>
        </div>

      </div>
      <div class="session-work-area col-sm-9" *ngIf="projectOpen == true">
        <div class="row strict h-100">
          <div class="col-xs-12 h-100">
            <div class="session-work-area-layout">
              <div class="session-work-area-layout-tool row strict pt-2 pr-2 pb-2">
                <div class="col-xs-12 work-layout">
                  <section class="mind-map-tool h-100" *ngIf="currentView == 'landscaper'">
                    <div class="h-100">
                      <app-landscaper></app-landscaper>
                    </div>
                  </section>
                  <section class="mind-map-tool h-100" *ngIf="currentView == 'mindMapping'">
                    <div class="h-100">
                      <app-mind-elixir-mindmapping></app-mind-elixir-mindmapping>
                    </div>
                  </section>
                  <section class="personamapper h-100" *ngIf="currentView == 'personaMapper'">
                    <div class="h-100">
                      <app-persona-mapper></app-persona-mapper>
                    </div>
                  </section>
                  <section class="personamapper h-100" *ngIf="currentView == 'personaMapperMindMap'">
                    <div class="h-100">
                      <app-persona-mapper-mind-map></app-persona-mapper-mind-map>
                    </div>
                  </section>
                  <section class="personamapper h-100" *ngIf="currentView == 'personaMapperEntityMindMap'">
                    <div class="h-100">
                      <app-persona-mapper-entity-mind-map></app-persona-mapper-entity-mind-map>
                    </div>
                  </section>
                  <section class="interactionmapper h-100" *ngIf="currentView == 'interactionMapper'">
                    <div class="h-100">
                      <app-interaction-mapper></app-interaction-mapper>
                    </div>
                  </section>
                  <section class="interactionmapper h-100" *ngIf="currentView == 'interactionMapperMindMap'">
                    <div class="h-100">
                      <app-interaction-mapper-mind-map></app-interaction-mapper-mind-map>
                    </div>
                  </section>
                  <section class="scopemapper h-100" *ngIf="currentView == 'scopeMapper'">
                    <div class="h-100">
                      <app-scope-mapper></app-scope-mapper>
                    </div>
                  </section>
                  <section class="scopemapper h-100" *ngIf="currentView == 'scopeMapperMindMap'">
                    <div class="h-100">
                      <app-scope-mapper-mind-map></app-scope-mapper-mind-map>
                    </div>
                  </section>
                  <section class="scopemapper h-100" *ngIf="currentView == 'scopeMapperEntityMindMap'">
                    <div class="h-100">
                      <app-scope-mapper-entity-mind-map></app-scope-mapper-entity-mind-map>
                    </div>
                  </section>
                  <section class="environmentmapper h-100" *ngIf="currentView == 'environmentMapper'">
                    <div class="h-100">
                      <app-environment-mapper></app-environment-mapper>
                    </div>
                  </section>
                  <section class="taskplanner h-100" *ngIf="currentView == 'taskPlanner'">
                    <div class="h-100">
                      <app-task-planner></app-task-planner>
                    </div>
                  </section>
                  <section class="taskplanner h-100" *ngIf="currentView == 'sprintPlanner'">
                    <div class="h-100">
                      <app-sprint-planner></app-sprint-planner>
                    </div>
                  </section>
                  <section class="taskplanner h-100" *ngIf="currentView == 'jirabugsMapper'">
                    <div class="h-100">
                      <app-jirabugs-mapper></app-jirabugs-mapper>
                    </div>
                  </section>
                  <section class="taskplanner h-100" *ngIf="currentView == 'entityTest'">
                    <div class="h-100">
                      <app-entity-test></app-entity-test>
                    </div>
                  </section>
                  <section class="taskplanner h-100" *ngIf="currentView == 'taskPlanner'">
                    <div class="h-100">
                      <app-task-planner></app-task-planner>
                    </div>
                  </section>
                  <section class="deepdive h-100" *ngIf="currentView == 'deepDive'">
                    <div class="h-100">
                      <app-deep-dive></app-deep-dive>
                    </div>
                  </section>
                  <section class="testdesigner h-100" *ngIf="currentView == 'testDesigner'">
                    <div class="h-100">
                      <app-test-designer></app-test-designer>
                    </div>
                  </section>
                  <section class="checklist h-100" *ngIf="currentView == 'checklist'">
                    <div class="h-100">
                      <app-checklist></app-checklist>
                    </div>
                  </section>
                  <section class="validator h-100" *ngIf="currentView == 'testExecutor'">
                    <div class="h-100">
                      <app-test-executor></app-test-executor>
                    </div>
                  </section>
                  <section class="testmanager h-100" *ngIf="currentView == 'testManager'">
                    <div class="h-100">
                      <app-test-manager></app-test-manager>
                    </div>
                  </section>
                  <section class="dashboard h-100" *ngIf="currentView == 'dashboardTest'">
                    <div class="h-100">
                      <app-dashboard></app-dashboard>
                    </div>
                  </section>
                  <section class="dashboard h-100" *ngIf="currentView == 'dashboardExecution'">
                    <div class="h-100">
                      <app-dashboard-execution></app-dashboard-execution>
                    </div>
                  </section>
                  <section class="dashboard h-100" *ngIf="currentView == 'dashboardQuality'">
                    <div class="h-100">
                      <app-dashboard-quality></app-dashboard-quality>
                    </div>
                  </section>
                  <div class="notify-app readOnlyForm">
                    <div class="modal right fade" id="notifySection" tabindex="-1" role="dialog">
                      <div class="h-100">
                        <app-notifications></app-notifications>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="jira-app readOnlyForm">
                    <div class="modal right fade" id="jiraBugList" tabindex="-1" role="dialog">
                      <div class="h-100">
                        <app-jira-bugs-list></app-jira-bugs-list>
                      </div>
                    </div>
                  </div> -->
                  <div class="note-app readOnlyForm">
                    <div class="modal right fade" id="myNote" tabindex="-1" role="dialog">
                      <div class="h-100">
                        <app-my-notes></app-my-notes>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-3 h-100" *ngIf="myNotesOpen == true && chatGPTOpen == false">
        <div class="no-gutter h-100">
          <app-my-notes></app-my-notes>
        </div>
        <!-- <app-my-notes></app-my-notes> -->
      </div>
      <div class="col-sm-3 h-100" *ngIf="chatGPTOpen == true && myNotesOpen == false">
        <div class="no-gutter h-100">
          <app-chat-gpt-assistant></app-chat-gpt-assistant>
        </div>
        <!-- <app-my-notes></app-my-notes> -->
      </div>
      <!-- <div class="session-view-height" *ngIf="currentView == 'personaMapper'">
        <app-persona-mapper></app-persona-mapper>
      </div>
      <div class="session-view-height" *ngIf="currentView == 'deepDive'">
        <app-deep-dive></app-deep-dive>
      </div> -->
    </div>
  </section>
</div>